import React from "react";

const ContactUs = () => {
  return (
    <div className="about__tab_p">
      <h4>Contact Us </h4>
      <p>
        As a company operating in the internet sector, e-mail is our
        communication channel where we can help you in the best and fastest way.
        You can reach us very quickly by filling out the contact form on our
        site . If you are contacting on behalf of the company, please fill out
        the corporate contact form.
      </p>
      <p>
        <strong>Company Title:</strong> GALATA ANKET
      </p>
      <p>
        <strong>Email:</strong> support@admin.com
      </p>
      <p>
        <strong>Phone:</strong> +92 3346 4673
      </p>
    </div>
  );
};

export default ContactUs;
